<template>
  <div v-loading="loading">
    <div v-if="isFileUploaded">
      <button href="#" class="btn btn-primary mb-3" @click="handleViewURL(files[0].document, $event)">View</button>
      <button href="#" class="btn btn-danger mb-3" v-if="files[0].document_type && files[0].document_type.id"
        @click="reuploadFiles">ReUpload</button>
      <button href="#" class="btn btn-danger mb-3" v-else @click="removeFile">Remove</button>
    </div>
    <dropzone v-else ref="myVueDropzoneCustom" id="myVueDropzoneCustom" :multiple="multiple" :v-model="files"
      :auto-upload="false" :options="dropzoneOptions" @vdropzone-file-added="handleFileAdded">
      <template v-slot="dropzoneProps">
        <div class="dz-message">
          <p>Drag & drop files here or click to upload.</p>
        </div>
      </template>
    </dropzone>


  </div>
</template>

<script>
import Vue from "vue";
import Dropzone from "vue2-dropzone";

export default {
  components: {
    Dropzone
  },
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: () => []
    },
    onFileUpload: {
      type: Function,
      required: true
    },
    dropzoneOptions: {
      type: Object,
      default: () => ({
        maxFiles: 10,  // Default to max 10 files
        acceptedFiles: "image/*", // Default accepted file types
        dictDefaultMessage: "Drag & drop files here or click to upload." // Custom message
      })
    },
    document_type: {
      type: Object,
      default: () => ({
        id: null,
        name: null,
      })
    }
  },
  data() {
    return {
      files: [], // Local state to hold uploaded files
      loading: false // Add loading state
    };
  },
  watch: {
    value: {
      handler(newValue) {
        this.files = newValue;
      },
      deep: true
    },
    files: {
      handler(newFiles) {
        const isAvailable = newFiles.filter(e => e).length > 0;
        if (isAvailable) {
          this.$emit("update:value", newFiles);
        }
      },
      deep: true
    }
  },
  computed: {
    isFileUploaded() {
      return Boolean(this.files[0] && this.files[0].isUploaded);
    }
  },
  mounted() {
    this.files = this.value;
  },
  methods: {
    async handleViewURL(file, e) {
      e.preventDefault();
      e.stopPropagation();

      if (!file) {
        console.error("File is not defined or invalid.");
        return;
      }

      if (file instanceof Blob || file instanceof File) {
        // Convert the Blob/File to a base64 string
        try {
          const base64String = await this.fileToBase64(file);
          const blob = await fetch(base64String).then(response => response.blob());
          const objectURL = URL.createObjectURL(blob);
          window.open(objectURL, "_blank");
        } catch (error) {
          console.error("Error converting file to base64 or fetching blob:", error);
        }
      } else if (typeof file === "string") {
        window.open(file, "_blank");
      } else {
        console.log(file)
        console.error("Unsupported file type.");
      }
    },

    fileToBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file); // Ensure 'file' is a Blob/File
      });
    },

    async handleFileAdded(file) {
      if (await this.onFileUpload(file, this.$refs.myVueDropzoneCustom)) {
        Vue.set(this.files, 0, {
          ...this.files[0],
          file: file,
          document: file,
          document_type: this.document_type,
          name: file.name,
          isUploaded: true
        });
      } else {
        console.log('else: ', file);
        Vue.set(this.files, 0, null);
        this.$refs.myVueDropzoneCustom.removeFile(file);
      }
    },
    reuploadFiles(e) {
      e.preventDefault();
      e.stopPropagation();

      Vue.set(this.files, 0, {
        ...this.files[0],
        isUploaded: false
      });
    },
    removeFile(e) {
      e.preventDefault();
      e.stopPropagation();
      if (!this.files[0].document_type) {
        this.loading = true; // Set loading to true before API call
        this.$store.dispatch('deleteUploadedDocument', this.files[0].id)
          .then(response => {
            this.$emit('reload-files');
          })
          .catch(error => {
            console.error('Error deleting document:', error);
          })
          .finally(() => {
            this.loading = false; // Set loading to false after API call
          });
      }
      Vue.set(this.files, 0, {
        ...this.files[0],
        isUploaded: false
      });
    }
  }
};
</script>

<style scoped>
.dz-message {
  text-align: center;
  padding: 20px;
}

/* Add loading overlay styles */
.el-loading-mask {
  background-color: rgba(255, 255, 255, 0.8);
}
</style>